import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  cursor: ", ";\n  display: inline-flex;\n  flex-basis: 100%;\n  flex-direction: column;\n  justify-content: flex-start;\n  max-width: ", ";\n  min-width: ", ";\n  overflow: ", ";\n  position: relative;\n  text-align: center;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  -ms-hyphens: auto;\n  -o-hyphens: auto;\n  word-break: break-word;\n  hyphens: auto;\n\n  &:not(:last-child) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
export var propTypes = {
  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  typographyConfig: PropTypes.object,

  /**
   * @ignore
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * @ignore
   */
  labelMargin: PropTypes.number,

  /**
   * @ignore
   */
  labelMaxWidth: PropTypes.number,

  /**
   * @ignore
   */
  labelMinWidth: PropTypes.number,

  /**
   * @ignore
   */
  lastChild: PropTypes.bool,

  /**
   * @ignore
   */
  theme: PropTypes.object,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  focusSize: PropTypes.func,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  lastChild: false
};
/**
 * @ignore
 */

var StyledLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "StyledLabel",
  componentId: "asksmw-0"
})(_templateObject(), function (_ref) {
  var bodyConfig = _ref.bodyConfig,
      getFontStyles = _ref.getFontStyles,
      typescale = _ref.typescale;
  return getFontStyles(bodyConfig, typescale);
}, function (_ref2) {
  var colorConfig = _ref2.colorConfig;
  return colorConfig.black;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_ref4) {
  var maxWidth = _ref4.maxWidth;
  return calculateRem(maxWidth);
}, function (_ref5) {
  var minWidth = _ref5.minWidth;
  return calculateRem(minWidth);
}, function (_ref6) {
  var focusSize = _ref6.focusSize;
  return focusSize ? 'visible' : 'hidden';
}, function (_ref7) {
  var margin = _ref7.margin;
  return calculateRem(margin);
});

var ColorLabel = function ColorLabel(props) {
  var bodyConfig = props.bodyConfig,
      disabled = props.disabled,
      labelMargin = props.labelMargin,
      labelMaxWidth = props.labelMaxWidth,
      labelMinWidth = props.labelMinWidth,
      theme = props.theme,
      typescaleProp = props.typescale,
      typographyConfig = props.typographyConfig,
      colorConfig = props.colorConfig;
  var typescale = typescaleProp;
  if (!typescaleProp) typescale = typographyConfig.getTypescale();

  function _getFontStack(bodyConfig, typescale, typographyConfig) {
    return bodyConfig.getStyles(typescale, 'desktop', 'small');
  }

  function _getFontStyles() {
    var fontStack = _getFontStack(bodyConfig, typescale, typographyConfig);

    return "\n      font-family: ".concat(fontStack.fontFamily, ";\n      font-size: ").concat(calculateRem(fontStack.fontSize), ";\n      line-height: ").concat(calculateRem(fontStack.lineHeight), ";\n    ");
  }

  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    bodyConfig: bodyConfig,
    disabled: disabled,
    getFontStyles: _getFontStyles,
    margin: labelMargin,
    maxWidth: labelMaxWidth,
    minWidth: labelMinWidth,
    theme: theme,
    typescale: typescale,
    colorConfig: colorConfig
  }, props));
};

ColorLabel.propTypes = propTypes;
ColorLabel.defaultProps = defaultProps;
export default ColorLabel;